<app-site-settings-menu>
    <mat-card *ngIf="hasFeatureAccess" class="mat-elevation-z0">
        <mat-card-title class="header">
            <h1 appLocalizationPopupDirective localizationCode="ArticleEditor">{{ 'ArticleEditor' | translate: {Default: "Article Editor"} }}</h1>

            <div>
                <button mat-stroked-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="backToArticles()">
                    {{ 'BackToArticles' | translate: {Default: 'Back To Articles'} }}
                </button>

                <button 
                mat-raised-button 
                setColor="primaryColour" 
                color="primary" [disabled]="formValid === false" 
                appPreventDoubleClick 
                (throttledClick)="save()"
                >{{ 'Save' | translate: {Default: "Save"} }}</button>
            </div>

        </mat-card-title>
        <mat-card-content>
            <div class="container">
                <app-form-generator 
                    *ngIf="!loading && formId"
                    [formId]="formId"
                    [formData]="formData"
                    (emitFormData)="formDataEmitted($event)"
                    (emitFormDataChange)="formDataEmitted($event)"
                    (emitFormPristine)="formPristineEmitted($event)"
                    (emitFormStatus)="formStatusUpdated($event)"
                ></app-form-generator>
    
                <ng-container *ngIf="fileToUpload !== null && filePreview; else noPreview">
                    <img [src]="filePreview" alt="Article Image Preview" style="max-width: 100%; max-height: 200px; margin-top: 10px;">
                </ng-container>
                <ng-template #noPreview>
                    <div *ngIf="articleImage$ | withLoading | async as articleImage">
                        <ng-template [ngIf]="articleImage.value">
                            <img class="profiler" [src]="articleImage.value" style="max-width: 100%; max-height: 200px; margin-top: 10px;">
                        </ng-template>
                        <ng-template [ngIf]="articleImage.error">
                            Error
                        </ng-template>
                        <ng-template [ngIf]="articleImage.loading">
                            <ngx-skeleton-loader
                                class="profiler skeleton-loader"
                                count="1"
                                appearance="circle"
                                [theme]="{
                                    'height.px': height,
                                    'width.px': width
                                }"
                            ></ngx-skeleton-loader>
                        </ng-template>
                    </div>
                </ng-template>
            </div>
        </mat-card-content>
    </mat-card>

    <no-feature-access *ngIf="!hasFeatureAccess"></no-feature-access>
</app-site-settings-menu>